enum ExternalEvent {
  ChildHeightChanged = 'childHeightChanged',
}

export default ExternalEvent;
